import { BinaryWriter, utils } from '@neo-one/client-common';
import { IntegerContractParameter } from '@neo-one/node-core';
import { MAX_SIZE_BIG_INTEGER } from '../constants';
import { IntegerTooLargeError, InvalidValueStorageContextStackItemError } from './errors';
import { StackItemBase } from './StackItemBase';
import { StackItemType } from './StackItemType';
import { StorageContextStackItem } from './StorageContextStackItem';
export class IntegerStackItem extends StackItemBase {
    constructor(value, safe = true) {
        super();
        this.value = value;
        if (safe && this.asBuffer().length > MAX_SIZE_BIG_INTEGER) {
            throw new IntegerTooLargeError();
        }
    }
    asBigInteger() {
        return this.value;
    }
    asBoolean() {
        return !this.value.isZero();
    }
    asBuffer() {
        return utils.toSignedBuffer(this.value);
    }
    asStorageContextStackItem({ currentBlockIndex, vm, scriptHash, callingScriptHash, entryScriptHash, }) {
        if (currentBlockIndex <= vm.storageContext.v0.index) {
            const storageContext = this.asBigInteger().toNumber();
            let hash;
            switch (storageContext) {
                case 1:
                    hash = scriptHash;
                    break;
                case 2:
                    hash = callingScriptHash;
                    break;
                case 4:
                    hash = entryScriptHash;
                    break;
                default:
            }
            if (hash !== undefined) {
                return new StorageContextStackItem(hash);
            }
        }
        throw new InvalidValueStorageContextStackItemError();
    }
    toContractParameter(_seen = new Set()) {
        return new IntegerContractParameter(this.value);
    }
    serializeInternal() {
        const writer = new BinaryWriter();
        writer.writeUInt8(StackItemType.Integer);
        writer.writeVarBytesLE(utils.toSignedBuffer(this.value));
        return writer.toBuffer();
    }
}

//# sourceMappingURL=IntegerStackItem.js.map
